import clsx from 'clsx'
import {HTMLProps} from 'react'

export interface GridContainerProps extends HTMLProps<HTMLDivElement> {
  /**
   * Determines whether default column configuration should be disabled.
   *
   * @default false
   */
  disableDefaultColumns?: boolean
}

export function GridContainer({
  className,
  children,
  disableDefaultColumns,
  ...props
}: GridContainerProps) {
  return (
    <div
      className={clsx(
        `grid`,
        !disableDefaultColumns && 'grid-cols-1 sm:grid-cols-2',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default GridContainer
